import { api, type PurchaseCheckoutInput } from "./api";
import type { PurchasePreview } from "../components/PurchaseConfirmation";

export function purchaseCheckoutInput(preview: PurchasePreview): PurchaseCheckoutInput {
  return { itemId: preview.itemId, qty: preview.qty, paymentMethod: preview.paymentMethod, expectedTotal: preview.total,
    arrangementQuoteId: preview.handover?.quoteId || undefined,
    expectedPickup: preview.handover && !preview.handover.quoteId ? { location: preview.handover.location, schedule: preview.handover.schedule } : undefined,
    ...(preview.requestKey ? { requestKey: preview.requestKey, expectedDocumentId: preview.document?.id } : {}) };
}

/** A mounted review retains its exact request after an uncertain payment.
 * Historical Items remain in their existing checkout, without inferred assent. */
export async function preparePurchaseReview(preview: PurchasePreview, captured: boolean) {
  if (!captured) return preview;
  const draft = { ...preview, requestKey: crypto.randomUUID() };
  const current = await api.previewPurchaseCheckout(purchaseCheckoutInput(draft));
  if (!current?.document) throw new Error("The complete seller-offered agreement is unavailable. Retry review before paying.");
  return { ...draft, document: current.document, sellerOfferDocument: current.sellerOfferDocument };
}
